<template>
  <div class="animated fadeIn">
    <b-row class="mb-3">
      <b-col cols="2" class="pt-2">Sample ID</b-col>
      <b-col>
        <b-form-input
          type="text"
          v-model="identifier"
          placeholder="Sample Name"
          :state="!$v.identifier.$invalid"
          invalid-feedback="Required"
        />
      </b-col>
      <b-col v-if="samples.length > 1" cols="1" class="pl-0">
        <b-button @click="removeSample" variant="danger" block>
          <i class="fa fa-trash" />
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Sample Usage"
          :label-cols="2"
          :state="!$v.usage.$invalid"
          invalid-feedback="Required"
          :horizontal="true"
        >
          <add-on-select
            :selectedItem="usage"
            customPlaceholder="Select Sample Usage"
            :options="usageOptions"
            @change="handleSelect"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group label="Add On(s)" label-cols="2">
      <b-button
        v-b-toggle="`addOns-${sampleId}${submissionId}`"
        :variant="add_ons.length ? 'primary' : 'dark'"
        block
        >Options</b-button
      >
      <b-collapse :id="`addOns-${sampleId}${submissionId}`" class="mt-2">
        <custom-form-checkbox-group
          v-model="add_ons"
          v-if="addOns.length"
          :lg="2"
          :md="2"
          :options="
            addOns.map(i => ({ text: i.name, value: i.id, icon: 'cube' }))
          "
        />
      </b-collapse>
    </b-form-group>
    <hr />
  </div>
</template>

<script>
import AddOnSelect from "../../misc/AddOnSelect";
import CustomFormCheckboxGroup from "@/components/shared/form/CustomFormCheckboxGroup";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectWaterSampleFormGroup",
  components: { AddOnSelect, CustomFormCheckboxGroup },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: ""
    },
    sampleId: {
      type: String,
      default: ""
    },
    addOns: {
      type: Array,
      default: () => []
    },
    usageOptions: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission"
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    sample() {
      return this.samples.find(
        sample => sample.test_package_sample_id === this.sampleId
      );
    },
    sample_water() {
      return this.sample.sample_water;
    },
    usage() {
      return this.sample_water.usage;
    },
    identifier: {
      get() {
        return this.sample.identifier;
      },
      set(value) {
        this.handleSampleChange({
          field: "identifier",
          value
        });
      }
    },
    add_ons: {
      get() {
        return this.sample.add_ons;
      },
      set(value) {
        this.handleSampleChange({
          field: "add_ons",
          value
        });
      }
    }
  },
  validations: {
    identifier: { required },
    usage: { required }
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION_SAMPLE"]),
    handleSampleChange({ field, value }) {
      this.UPDATE_SUBMISSION_SAMPLE({
        submission_id: this.submissionId,
        sample_id: this.sampleId,
        sample_update: {
          ...this.sample,
          [field]: value
        }
      });
    },
    handleSelect({ selected, field }) {
      this.handleSampleChange({
        value: {
          ...this.sample_water,
          [field]: selected
        },
        field: "sample_water"
      });
    },
    removeSample() {
      this.$emit("updateSampleList", "remove", this.sampleId);
    }
  }
};
</script>
